export const operationConditions = [
    { value: 1, label: 'Contado' },
    { value: 2, label: 'Crédito' },
]
